import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@monorepo/helpers';
import { DictResponse } from '@spilca/order_ts/v1/order/enum_pb';
import { translateNormalizedDictionary } from '@monorepo/dictionary';
import { REQUEST_TYPES, useGetRequest } from '@monorepo/requests';

const useGetCultures = (
  filter: object | undefined,
  active: string | null = null
) => {
  const getTypes = useGetRequest(REQUEST_TYPES.GET_ORDERS_CULTURES_REQUEST);
  return useQuery({
    queryKey: [QUERY_KEYS.LIST_ORDERS_CATEGORIES, filter],
    queryFn: (d): Promise<DictResponse.AsObject> => getTypes({ ...d, active }),
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 10*60*1000,
    gcTime: 60*1000,
    placeholderData: (previousData) => previousData,
    select: translateNormalizedDictionary(
      ({ name, count }) => `${name} (${count})`,
      null,
      'id',
      (item) => `culture-${item.id}-${item.name}`
    )
  });
};

export default useGetCultures;
